import ComponentWrapper from '../../common/ComponentWrapper';
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Button } from '@mui/material';
import CommonStyles from '../../common/CommonStyles';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';

import LogComment from './component/LogComment';
import moment from 'moment';
import AutocompleteSelect from '../../common/AutocompleteSelect';
import TrplsTableStyles from '../../common/TrplsTable/TrplsTableStyles';
import LoaderNew from '../../common/LoaderNew';

import { FirstPageOutlined, LastPageOutlined } from '@mui/icons-material';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';

import { getUrlParameter, setUrlParameter, removeUrlParameter } from '../../utils';

const styles = {
  ...CommonStyles,
  ...TrplsTableStyles,
  tblHeadCell: {
    padding: '10px'
  },
  tblCell: {
    padding: '10px'
  },
  tblHeadRow: {
    background: 'white'
  },
  tblRow: {
    '&:nth-child(odd)': {
      backgroundColor: '#f8f8f8'
    },
    '&:nth-child(even)': {
      backgroundColor: '#fcfcfc'
    }
  },
};

class ActionsLog extends ComponentWrapper {

  state = {
    logs: [],
    nodes: {},
    total_logs: 0,
    actionTypes: [],
    userSelect: null,
    actionSelect: null,
    rowsToShow: 100,
    rowsToShowPage: 1,
    loaded: false,
  };

  componentDidMount() {
    this.onSearch();
  }

  getTime = (value) => {
    const date = moment(value).format('MMM DD YYYY, HH:mm');
    let diff = ~~((new Date().getTime() - value) / 1000);

    if (diff < 60) {//< 1min
      diff = diff + 's';
    } else if (diff >= 60 && diff < (60 * 60)) {//1min - 1h
      diff = '~' + ~~(diff / 60) + 'm';
    } else if (diff >= (60 * 60) && diff < (60 * 60 * 24)) {//1h - 1d
      diff = '~' + ~~(diff / (60 * 60)) + 'h';
    } else {
      diff = '~' + ~~(diff / (60 * 60 * 24)) + 'd';
    }

    return `[${date}]${diff}`;
  };

  onUserSelectChange = option => {
    this.setState({
      userSelect: option,
      acc: option.value
    });
    setUrlParameter('acc', option.value);
  };

  onActionSelectChange = option => {
    this.setState({
      actionSelect: option,
      act_type: option.value
    });
    setUrlParameter('act_type', String(option.value).toLowerCase());
  };

  onPageChange = rowsToShowPage => {
    this.setState({ rowsToShowPage });
    setUrlParameter('p', rowsToShowPage);
  };

  onFilterChange = (key, value) => {
    if (value) setUrlParameter([key], value);
    else removeUrlParameter(key);
  };

  onSearch = () => {
    this.setState({ loaded: false }, () => {
      let { acc, act_type, rowsToShowPage: p } = this.state;

      acc = getUrlParameter('acc') || acc;
      act_type = getUrlParameter('act_type') || act_type;
      p = getUrlParameter('p') || p;

      let nid = getUrlParameter('nid');
      let pid = getUrlParameter('pid');

      this.get({
        url: `/rest/get_logactivity?${acc ? `acc=${acc}` : ''}${act_type ? `&act_type=${act_type}` : ''}${
          p ? `&p=${p}` : ''}${nid ? `&nid=${nid}` : ''}${pid ? `&pid=${pid}` : ''}`,
        cb: (data) => {
          this.setState({
            logs: data.logs || [],
            total_logs: data.total_logs || 0,
            actionTypes: data.action_types || [],
            nodes: data.nodes || {},
            loaded: true
          }, () => {
            if (this.mainContainer) this.mainContainer.scrollTo(0, 0);
          });
        }
      });
    });
  };

  getTablePagination = (isTop) => {
    const { classes } = this.props;
    const { rowsToShow, rowsToShowPage, total_logs } = this.state;

    return (
      <div
        style={{
          width: 'fit-content',
          minHeight: '30px',
          height: '30px',
        }}
      >
        <TablePagination
          component="div"
          rowsPerPage={rowsToShow}
          onPageChange={() => {
            console.log('page changed');
          }}
          page={rowsToShowPage - 1}
          SelectProps={{
            classes: {
              root: classes.paginationSelectRoot
            },
            MenuProps: {
              classes: {
                paper: classes.paginationSelectMenu
              }
            }
          }}
          count={total_logs}
          style={{
            marginRight: '36px',
            marginBottom: isTop ? '0' : '',
            marginTop: isTop ? '0' : ''
          }}
          rowsPerPageOptions={[]}
          ActionsComponent={(props) => {
            const { page, count, rowsPerPage } = props;

            const prevPageDisabled = props.page === 0;
            const nextPageDisabled = page >= Math.ceil(count / rowsPerPage) - 1;

            return (
              <div className={classes.alignCenter}>

                <FirstPageOutlined
                  className={`${classes.paginationBtn} ${classes.mr20} ${
                    prevPageDisabled ? classes.paginationBtnDisabled : ''
                  }`}
                  style={{
                    marginLeft: '40px'
                  }}
                  onClick={() => {
                    if (!prevPageDisabled) {
                      this.onPageChange(1);
                      this.onSearch();
                    }
                  }}
                />

                <KeyboardArrowLeftOutlinedIcon
                  className={`${classes.paginationBtn} ${classes.mr20} ${
                    prevPageDisabled ? classes.paginationBtnDisabled : ''
                  }`}
                  onClick={() => {
                    if (!prevPageDisabled) {
                      this.onPageChange(rowsToShowPage - 1);
                      this.onSearch();
                    }
                  }}
                />

                <KeyboardArrowRightOutlinedIcon
                  className={`${classes.paginationBtn} ${classes.mr20} ${
                    nextPageDisabled ? classes.paginationBtnDisabled : ''
                  }`}
                  onClick={() => {
                    if (!nextPageDisabled) {
                      this.onPageChange(rowsToShowPage + 1);
                      this.onSearch();
                    }
                  }}
                />

                <LastPageOutlined
                  className={`${classes.paginationBtn} ${
                    nextPageDisabled ? classes.paginationBtnDisabled : ''
                  }`}
                  onClick={() => {
                    const lastPage = Math.ceil(count / rowsPerPage);
                    if (!nextPageDisabled) {
                      this.onPageChange(lastPage);
                      this.onSearch();
                    }
                  }}
                  style={{
                    opacity: `${nextPageDisabled ? '0.5' : '1'}`
                  }}
                />

              </div>
            );
          }}
        />
      </div>
    );
  };

  render() {
    const { classes, setup_accounts } = this.props;
    const {
      logs,
      nodes,
      loaded,
      total_logs,
      userSelect,
      rowsToShow,
      actionTypes,
      actionSelect,
    } = this.state;

    let accounts = [{ 'label': 'User (all)', 'value': 'all' }, { 'label': '', 'value': 0 }];
    if (setup_accounts && Object.keys(setup_accounts).length) {
      Object.keys(setup_accounts).forEach(key => accounts.push(
        { 'label': setup_accounts[key].login, 'value': setup_accounts[key].id }
      ));
    }

    const accParam = getUrlParameter('acc');
    let userSelectValue = accParam
      ? accounts.find(el => String(el.value) === accParam)
      : userSelect ? userSelect : accounts[0];

    let actions = [{ 'label': 'Action (all)', 'value': 'all' }];
    if (actionTypes) actionTypes.forEach(type => actions.push({ 'label': type, 'value': type.toLowerCase() }));

    const actTypeParam = getUrlParameter('act_type');
    let actionSelectValue = actTypeParam
      ? actions.find(el => el.value === actTypeParam)
      : actionSelect ? actionSelect : actions[0];

    return (
      <div>

        {!loaded && (
          <div className={classes.tableLoaderOverlay}>
            <LoaderNew/>
          </div>
        )}

        <div
          className={`trpls-table-container ${classes.tableContainer}`}
          style={{
            height: 'calc(100vh - 90px + 45px + 5px)',
            overflow: 'auto'
          }}
          ref={mainContainer => this.mainContainer = mainContainer}
        >

          <div className={`${classes.pageHeading} ${classes.spaceBetween}`} style={{ position: 'relative', zIndex: 1 }}>
            <h3>Action log</h3>

              <div style={{ position: 'relative', right: '25px' }}>
                {this.getTablePagination(true)}
              </div>
          </div>

          <Table style={{ margin: '1px 30px', width: '-webkit-fill-available', }}>
            <TableHead style={{ position: 'sticky', top: -1, zIndex: 500 }}>
              <TableRow className={classes.tblHeadRow}>

                <TableCell className={classes.tblHeadCell} style={{ width: '300px' }}>
                  <AutocompleteSelect
                    style={{ width: '300px' }}
                    value={userSelectValue}
                    options={accounts}
                    placeholder={'Choose user'}
                    onChange={option => {
                      this.onUserSelectChange(option);
                      this.onSearch();
                    }}
                  />
                </TableCell>

                <TableCell className={classes.tblHeadCell} style={{ width: '150px' }}>
                  Activity time
                </TableCell>

                <TableCell className={classes.tblHeadCell} style={{ width: '135px' }}>
                  <AutocompleteSelect
                    style={{ width: '135px' }}
                    value={actionSelectValue}
                    options={actions}
                    placeholder={'Choose action type'}
                    onChange={option => {
                      this.onActionSelectChange(option);
                      this.onSearch();
                    }}
                  />
                </TableCell>

                <TableCell
                  className={classes.tblHeadCell}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <span>Entity</span>

                  <input
                    className={classes.ml10}
                    placeholder={'node id'}
                    onChange={(e) => this.onFilterChange('nid', e.target.value)}
                  />

                  <input
                    className={classes.ml10}
                    placeholder={'predicate id'}
                    onChange={(e) => this.onFilterChange('pid', e.target.value)}
                  />

                  <Button
                    style={{ height: '22px' }}
                    className={`${classes.btnBigNormal} ${classes.ml10}`}
                    onClick={() => this.onSearch()}
                  >
                    Search
                  </Button>
                </TableCell>

              </TableRow>
            </TableHead>

            <TableBody>
              {logs && logs.length > 0 && (
                logs.map((log, logIndex) => {
                    return (
                      <TableRow key={logIndex} className={classes.tblRow}>

                        <TableCell className={classes.tblCell}>
                          <div>
                            {setup_accounts[log.accountId] && setup_accounts[log.accountId].login}
                          </div>
                        </TableCell>

                        <TableCell className={classes.tblCell}>
                          {this.getTime(log.time)}
                        </TableCell>

                        <TableCell className={classes.tblCell}>
                          {log.actionType}
                        </TableCell>

                        <TableCell className={classes.tblCell} style={{ wordBreak: 'break-all' }}>
                          <LogComment
                            log={log}
                            node={nodes[log.entityId]}
                            nodes={nodes}
                          />
                        </TableCell>

                      </TableRow>
                    );
                  }
                ))}
            </TableBody>

          </Table>

          {logs && logs.length > 0 && total_logs > rowsToShow && this.getTablePagination(false)}

          {loaded && (!logs || !logs.length) ? (
            <div className={classes.emptyTableText}>Nothing to show</div>
          ) : null}

        </div>

      </div>
    );
  }
}

export default connect((state) => ({
  setup_accounts: state.meta.setup_accounts
}))(withStyles(styles)(ActionsLog));
